import React from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import useSearch from '../../hooks/useSearch';
import PeopleList from './PeopleList';
import Search from '../Inputs/Search';

const FilteredList = ({classes, header, endAdornment, data, onItemClick, isBusy}) => {

  const [search, clearSearch, filteredData] = useSearch(data);

  return <>
    {typeof header === 'string'
      ? <Typography variant='h6' className={classes.title}>{header}</Typography>
      : header
    }
    <div className={classes.input}>
      <Search {...{clearSearch}} {...{search}}/>
    </div>
    <div className={classes.container}>
      {isBusy
        ? <CircularProgress/>
        : <PeopleList
          data={filteredData}
          onItemClick={onItemClick}
          endAdornment={endAdornment}
        />
      }
    </div>
  </>
};

FilteredList.propTypes = {
  classes: PropTypes.object.isRequired,
  header: PropTypes.node,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
    })).isRequired,
  onItemClick: PropTypes.func.isRequired,
  isBusy: PropTypes.bool,
  endAdornment: PropTypes.object
};

const styles = theme => ({
  title: {
    margin: theme.spacing(1),
  },
  input: {
    width: '100%',
    margin: `${theme.spacing(2)}px 0`,
  },
  container: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 10,
    overflow: 'auto'
  }
});

export default React.memo(withStyles(styles)(FilteredList));
